import React from 'react';
import { useParams } from 'react-router-dom';

import { LiveChat } from './live-chat';
import { useReactiveVar } from '@apollo/client';
import { setIsLiveChat } from '../../../../graphql/configuration/configuration.cache';

export const LiveChatRoute = (): JSX.Element => {
  const isLiveChat = useReactiveVar(setIsLiveChat);
  const { id } = useParams<{ id?: string }>();
  const [firstName, myAcuvueId] = (id ?? '').split(';');

  return isLiveChat ? <LiveChat firstName={firstName} myAcuvueId={myAcuvueId} /> : <></>;
};
